import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@web-shared/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium leading-4 whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "border-transparent bg-secondary text-secondary-foreground",
        accent: "border-transparent bg-[color-mix(in_srgb,var(--primary)_20%,transparent)] text-primary",
        outline: "border-border text-muted-foreground",
        added: "border-transparent bg-[color-mix(in_srgb,var(--added)_20%,transparent)] text-[var(--added)]",
        removed: "border-transparent bg-[color-mix(in_srgb,var(--removed)_20%,transparent)] text-[var(--removed)]",
        changed: "border-transparent bg-[color-mix(in_srgb,var(--changed)_20%,transparent)] text-[var(--changed)]",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
export { badgeVariants };
